let CloseButton = require("./CloseButton");

class Blast extends React.Component {
  hide(evt) {
    if (this.props.onHide) {
      this.props.onHide();
    }

    ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this).parentNode);
  }

  render() {
    return (
      <div className="mc-blast mc-screen" data-level={this.props.level} data-follow={!!this.props.onFollow}>
        <div className="mc-blast-body" onClick={this.props.onFollow}>
          {this.props.message}
        </div>
        <div className="mc-blast-close">
          <CloseButton color="#fff" size={16} onClick={(e) => this.hide(e)} tabIndex="0"/>
        </div>
      </div>
    );
  }
}

Blast.defaultProps = {
  level: "info", // "info", "warn" or "error"
  onFollow: null,
  onHide: null
};

module.exports = Blast;